import React from 'react';
import { Loading } from '../Loading/Loading';

import { LoadingContainer } from './FrameLoader.styled';

export type FrameLoaderProps = {
  height: string;
};

export const FrameLoader = ({ height }: FrameLoaderProps) => (
  <LoadingContainer height={height}>
    <Loading />
  </LoadingContainer>
);
